import { Component, ElementRef, OnInit, signal, TemplateRef, ViewChild } from '@angular/core';
import { NemaService } from '../../Services/nema.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharedDataService } from '../../Services/SharedServices/shared-data.service';
import { MatDialog } from '@angular/material/dialog';
import { ImageDialogComponent } from './image-dialog/image-dialog.component';
import { ImagePopupComponent } from '../image-popup/image-popup.component';
import { RgsharedserviceService } from '../../Services/RGService/rgsharedservice.service';
import { HpaSharedServiceService } from '../../Services/HPAService/hpa-shared-service.service';
import { BSharedServiceService } from '../../Services/BService/b-shared-service.service';
import { FSharedServiceService } from '../../Services/FService/f-shared-service.service';
import { Router } from '@angular/router';

import {MatExpansionModule} from '@angular/material/expansion';
@Component({
  selector: 'app-first-selection',
  templateUrl: './first-selection.component.html',
  styleUrl: './first-selection.component.css'
})
export class FirstSelectionComponent implements OnInit {
  @ViewChild('firstCommonExpansion') firstCommonExpansion!: ElementRef;
  scrollToSecondComponent() {
    const secondComponent = document.querySelector('app-second-selection');
    if (secondComponent) {
      secondComponent.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  readonly panelOpenState = signal(true);
  
  
  @ViewChild('dialogTemplate') dialogTemplate!: TemplateRef<any>;
  public reducerForm!: FormGroup;
  public formDataArray: any = {};
  // formDataArray: { letter: string, number: string }[]=[];
  public inputSpeed:any;
  public inputRatio: any;
  public outputSpeed: number | null = null;
  formSubmitted = false;
  public showspinfo: boolean = false;
  public showcdinfo: boolean = false;

  constructor(public dialog: MatDialog,private service:NemaService, private formBuilder:FormBuilder,private sharedDataService: SharedDataService,private rgSharedService:RgsharedserviceService,private hpaSharedService:HpaSharedServiceService, private bSharedService:BSharedServiceService, private fSharedService: FSharedServiceService,private router: Router){}
  ngOnInit(): void {
    this.getInputSpeed();
    this.getInputRatio();
    this.init();
    const currentUrl = window.location.href.toLowerCase();
  if (currentUrl.includes('spineatools') ) {
      this.showspinfo = true;
      this.showcdinfo = false;
    } else {
      this.showspinfo = false;
      this.showcdinfo = true;
    }
      
  }
  
  public getReducer(reducer: any):void{
    this.service.getReducer(reducer).subscribe(result=>{
      if(result.body && Object.keys(result.body).length > 0){
        this.sharedDataService.setData(result.body);
      }else{
        alert("There are no standard reducers that match your input criteria. Please contact ae@conedrive.com");
      //   if (confirm("We don't have a reducer for your inputs. Please try different inputs or contact ae@conedrive.com")) {
      //     window.location.href = "mailto:ae@conedrive.com";
      // }
      
        this.sharedDataService.setData(result.body);
      }
    });
    
  }
  private init():void{
    this.reducerForm = this.formBuilder.group({
      inputSpeed:[null, Validators.required],
      inputRatio:[null, Validators.required],
      serviceFactor:[],
      inputPower:[],
      dutyCycle:['yes'],
      selectedUnits:['no']
    });
    this.reducerForm.get('inputSpeed')?.valueChanges.subscribe(() => this.calculateOutputSpeed());
    this.reducerForm.get('inputRatio')?.valueChanges.subscribe(() => this.calculateOutputSpeed());
  }
  
  checkValue(event:any) {
    debugger;

    var test = document.getElementById("inputPower");
    if(event.target.value<0){
      alert("Please enter positive number");
      event.target.value = "0.0";
    }
    // if(event.target.value.endsWith('.')){
    //   event.target.value = event.target.value+"0"
    //   // event.target.value = event.target.value.slice(0, -2);
    // }
    
    // if(event.target.value.length==1){
    //   event.target.value = event.target.value+".0"
    // }
    // if (event.target.value < 0) {
    //   event.target.value = 0.1;
    // }
  }
  checkValueSF(event:any){
    if(event.target.value<0){
      alert("Please enter service factor between 0.8 and 2.0");
      event.target.value = "0.8";
    }else{
      if(event.target.value>0){
        if(event.target.value<0.8){
          alert("Please enter service factor between 0.8 and 2.0");
        event.target.value = "0.8";
        }
        if(event.target.value>2.0){
        alert("Please enter service factor between 0.8 and 2.0");
        event.target.value = "2.0";
      }
        
      }
      

    }
    
    // if(event.target.value.length==1){
    //   event.target.value = event.target.value+".0"
    // }
    // if (event.target.value < 0.8) {
    //   event.target.value = 0.8;
    // }else if( event.target.value > 2.0){
    //   event.target.value = 2.0;
    // }
  }

  public formAllData():void{
    const selectedInputPower = document.getElementById("inputPower") as HTMLInputElement
    const selectedUnits = document.querySelector('input[name="selectedUnits"]:checked') as HTMLInputElement;
    const selectedRatio = document.getElementById("ratio") as HTMLInputElement
    const selectedSpeed = document.getElementById("inputSpeed") as HTMLInputElement
    const selectedDutyCycle = document.querySelector('input[name="dutyCycle"]:checked') as HTMLInputElement;
    const selectedServiceFactor = document.getElementById("serviceFactor") as HTMLInputElement
    const selectedOutputSpeed = document.getElementById("outputSpeed") as HTMLInputElement
    // this.formAllData = { selectedInputPower: selectedInputPower.value };

    this.formDataArray = {
      selectedInputPower: selectedInputPower?.value.toString(),
      selectedUnits: selectedUnits?.value,
      selectedRatio: selectedRatio?.value,
      selectedSpeed: selectedSpeed?.value,
      selectedDutyCycle: selectedDutyCycle?.value,
      selectedServiceFactor: selectedServiceFactor?.value.toString(),
      selectedOutputSpeed: selectedOutputSpeed?.value
    };

//update method
    this.sharedDataService.setAllFormData(this.formDataArray);
    // this.rgSharedService.setInputData(this.formDataArray);
    this.sharedDataService.setFormData(this.formDataArray);
    this.rgSharedService.setFormData(this.formDataArray);
    this.hpaSharedService.setFormData(this.formDataArray);
    this.bSharedService.setFormData(this.formDataArray);
    this.fSharedService.setFormData(this.formDataArray);
    
  }

  



  private getInputSpeed():void{
    this.service.getInputSpeed().subscribe(result=>{
      this.inputSpeed = result;
    },
    (error) => {
      console.error('Error fetching input speed :', error);
    })
  }
  private getInputRatio():void{
    this.service.getInputRatio().subscribe(result=>{
      this.inputRatio = result;
    },
    (error) => {
      console.error('Error fetching input speed :', error);
    })
  }
  private calculateOutputSpeed(): void {
    const selectedSpeed = this.reducerForm.get('inputSpeed')?.value;
    const selectedRatio = this.reducerForm.get('inputRatio')?.value;
    // this.outputSpeed = selectedSpeed && selectedRatio ? (selectedSpeed / selectedRatio).toFixed(1)) : null;
    this.outputSpeed = selectedSpeed && selectedRatio ? parseFloat((selectedSpeed / selectedRatio).toFixed(1)) : null;

  }
  showImagePopup = false;

  openImagePopup() {
    this.showImagePopup = true;
  }

  closeImagePopup() {
    this.showImagePopup = false;
  }

  onSubmit(): void {
    this.formSubmitted = true;
    if (this.reducerForm.valid) {
      const reducerData = {
        Speed: this.reducerForm.get('inputSpeed')?.value,
        Ratio: this.reducerForm.get('inputRatio')?.value,
        ServiceFactor: this.reducerForm.get('serviceFactor')?.value.toString(),
        Inputpower_Them: this.reducerForm.get('inputPower')?.value.toString(),
        DutyCycle: this.reducerForm.get('dutyCycle')?.value,
        Units:this.reducerForm.get('selectedUnits')?.value
      };
    
      this.getReducer(JSON.stringify(reducerData));
      this.formAllData();
      // this.scrollToSecondComponent();
    }else{
      // console.log("All the data is not filled yet");
    }
    



    // this.getReducer();
    // if (selectedValue && selectedValue !== 'None') {
    //   // Form is valid, continue with submission logic
    //   console.log('Form submitted with selectedInputSpeed:', selectedValue);
    //   // You can add additional logic here, like calling a service to send data to the server
    // } else {
    //   // Form is invalid, show a warning to the user
    //   console.log('Form is invalid. Please select an option.');
    // }
  }
  openDialog(){
    this.dialog.open(ImagePopupComponent)
  }

  openDialog1() {
    const dialogRef = this.dialog.open(this.dialogTemplate, {
      data: { title: 'Help', message: 'Here is some help information.' },
    });
  }

  closeDialog() {
    this.dialog.closeAll();
  }
  dutyCycleOn(){
    const checkbox = document.getElementById('dutyCycleYes') as HTMLInputElement;
    checkbox.checked = true;
    this.dialog.closeAll();
  }
  dutyCycleOff(){
    const checkbox = document.getElementById('dutyCycleNo') as HTMLInputElement;
    checkbox.checked = true;
    this.dialog.closeAll();
  }



  // DownloadPDFTest(){
  //   debugger;
  //   this.service.downloadPDFTest("RG2017.0LNCC012-----");
  // }
  // imageUrl:any;
  // ShowImageTest() {
  //   this.service.downloadImageTest1("RG2017.0LNCC012-----").subscribe({
  //     next: (response) => {
  //       const blob = new Blob([response], { type: 'image/jpeg' }); // Assuming the API returns a JPEG image
  //       const imageUrl = URL.createObjectURL(blob); // Create an object URL for the image
  //       this.imageUrl = imageUrl; // Set the image URL for binding in HTML
  //     },
  //     error: (error) => {
  //       console.error('Error downloading image:', error); // Handle errors
  //     }
  //   });
  // }
}


